import { getSourceTypeId, handleForbiddenResponse, handleOfflineResponse } from 'utilities'
import { setAuthTimeout } from './Auth/AuthActions'
import { invalidateAllCategoryCaches } from './components/Search/SearchActions'
import { invalidateAllCategoryCaches as invalidateAllWorkQueueCategoryCaches } from './components/MyWorkQueue/MyWorkQueueActions'
import { invalidateAllCategoryCaches as invalidateAllMyRecordsCategoryCaches } from './components/MyRecords/MyRecordsActions'
import store from './store'

export const DEV_PORT = 53013
export const DEV_API_URL = process.env.DEV_API_URL
export const BASE_URL = DEV_API_URL
  ? DEV_API_URL
  : process.env.API_PROXY
  ? 'http://' + process.env.PROXY_URL
  : process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test'
  ? `http://localhost:${DEV_PORT}`
  : ''

// const setAppError = (error) => ({
//   type: "SET_APP_ERROR",
//   errorType: 'danger',
//   error
// })

// const handleErrors = (response) => (
//   new Promise((resolve, reject) => {
//     console.log(response);
//     if(response.ok){
//       resolve(response)
//     }else{
//       // store.dispatch(setAppError())
//       // console.log("Got an error");
//       reject(response)
//     }
//   })
// )
//
// const catchErrors = response => {
//   store.dispatch(setAppError("It looks we can't reach the server right now. Check your internet connection and try again later."))
//   if(process.env.NODE_ENV !== "test"){console.error(response)}
// }

const handleCustomHeaders = response => {
  try {
    // Handle authorization headers
    let timeout = response.headers.get('session-timeout')
    if (timeout) {
      timeout = parseInt(timeout, 10)
      if (timeout) {
        setAuthTimeout(timeout)
      }
    }

    // Handle search cache invalidation
    let invalidateSearchCache = response.headers.get('invalidate-search-cache')
    if (invalidateSearchCache) {
      if (invalidateSearchCache === 'all') {
        invalidateAllCategoryCaches()(store.dispatch, store.getState)
      }
    }

    // Handle work queue cache invalidation
    let invalidateWorkQueueCache = response.headers.get('invalidate-work-queue-cache')
    if (invalidateWorkQueueCache) {
      if (invalidateWorkQueueCache === 'all') {
        invalidateAllWorkQueueCategoryCaches()(store.dispatch, store.getState)
      }
    }

    // Handle work queue cache invalidation
    let invalidateMyRecordsCache = response.headers.get('invalidate-my-records-cache')
    if (invalidateMyRecordsCache) {
      if (invalidateMyRecordsCache === 'all') {
        invalidateAllMyRecordsCategoryCaches()(store.dispatch, store.getState)
      }
    }
  } catch (e) {
    console.error(e)
  }
}

const parseResponse = response =>
  new Promise((resolve, reject) => {
    const contentType = response.headers.get('content-type') || ''
    const responseIsJson = contentType.toLowerCase().includes('application/json')

    handleCustomHeaders(response)

    if (response.status === 403) {
      handleForbiddenResponse()
    }

    if (response.status === 503) {
      handleOfflineResponse()
    }

    if (response.status === 204) {
      response.text().then(resolve)
      return
    }

    if (response.status === 200) {
      if (responseIsJson) {
        response.json().then(resolve)
        return
      } else {
        response.text().then(resolve)
        return
      }
    }

    if (response.status !== 200) {
      //       console.warn(
      // `The requested route responded with an unhandled status: \
      // ${response.status} (${response.statusText}). If this is unexpected, \
      // check the controller method for route: ${response.url}.`
      //       )
      if (responseIsJson) {
        response.text().then(text => {
          try {
            const parsed = JSON.parse(text)
            if (response.ok) {
              resolve(parsed)
            } else {
              reject(parsed)
            }
          } catch (e) {
            console.warn(
              `The server responded with a content-type of "${contentType}" \
but json parsing failed. The response will be returned as \
plain text. For performance reasons, if the response body is \
not json, content-type should be set to "text/plain". Check \
the controller method for route: ${response.url}`
            )
            reject(text)
          }
        })
        return
      } else {
        response.text().then(text => {
          if (response.ok) {
            resolve(text)
          } else {
            reject(text)
          }
        })
      }
    }
  })

const fetchAndCatch = (props, callback, errorCallback) => {
  let auth = {}
  let AUTH = localStorage.getItem('WEB_USER_AUTHENTICATION')
  auth = AUTH && AUTH !== 'undefined' ? JSON.parse(AUTH) : {}
  let request
  switch (props.method) {
    case 'PUT':
    case 'POST':
      request = {
        method: props.method,
        headers: new Headers({
          'content-type': 'application/json',
          Authorization: auth.ID,
          ...props.headers
        }),
        body: props.body ? props.body : JSON.stringify({})
      }
      break
    case 'GET':
    default:
      request = {
        method: 'GET',
        headers: new Headers({
          Authorization: auth.ID,
          ...props.headers
        })
      }
  }
  if (props.cookies) {
    request.credentials = 'include'
  }
  if (props.getSignal && window.AbortController) {
    const controller = new AbortController()
    request.signal = controller.signal
    props.getSignal(controller)
  }
  fetch(`${BASE_URL}${props.url}`, request)
    // .then(handleErrors)
    .then(response => {
      // debugger;
      if (props.raw) {
        return response
      } else {
        return parseResponse(response)
      }
    })
    .then(response => {
      callback(response, props)
    })
    .catch(err => {
      if (errorCallback) {
        errorCallback(err)
      } else {
        callback(err)
        console.warn(
          `The request for route: ${props.url} did not provide an error callback. The success callback was used instead.`
        )
      }
    })
}

export const GET = (url, callback, errorCallback) => {
  fetchAndCatch({
    url: url,
    method: 'GET'
  },
  callback,
  errorCallback
  )
}

export const SEARCH = (payload, category, callback, errorCallback) => {
  const print = payload.PRINT
  delete payload.PRINT
  fetchAndCatch(
    {
      url: `/api/Records/${category}search${print ? '?print=true' : ''}`,
      method: 'POST',
      body: JSON.stringify(payload)
    },
    callback,
    errorCallback
  )
}

export const GET_SEARCH_DESCRIPTION = (category, callback) => {
  fetchAndCatch(
    {
      url: `/api/search/description/${category}`,
      method: 'GET'
    },
    callback
  )
}

export const GET_MY_RECORDS = (category, parameters, requestId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Records/GetMyRecords/${category}`,
      method: 'POST',
      auth: true,
      body: JSON.stringify(parameters),
      requestId
    },
    callback,
    errorCallback
  )
}

export const GET_FILING_DETAILS = (
  category,
  recordId,
  isPublicView,
  getSignal,
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: `/api/FilingDetail/${category}/${recordId}/${isPublicView}`,
      method: 'GET',
      getSignal
    },
    callback,
    errorCallback
  )
}

export const GET_ALL_WIZARDS = (category, callback) => {
  fetchAndCatch(
    {
      url: `/api/FormDefinition/${category ? `category/${category}` : ''}`,
      method: 'GET'
    },
    callback
  )
}

export const GET_LOOKUP_GROUPS = (type, callback) => {
  fetchAndCatch(
    {
      url: `/api/LookupGroup/${type}`,
      method: 'GET'
    },
    callback
  )
}

export const GET_LOOKUP_SUB_GROUPS = (id, callback) => {
  fetchAndCatch(
    {
      url: `/api/LookupSubGroup/${id}`,
      method: 'GET'
    },
    callback
  )
}

export const GET_GROUP_ITEMS = (groupId, callback) => {
  const query = store.getState().router.location.search || ''
  fetchAndCatch(
    {
      url: `/api/GroupItems/${groupId}${query}`,
      method: 'GET'
    },
    callback
  )
}

export const VALIDATE = (type, payload, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Validation`,
      method: 'POST',
      body: JSON.stringify({ type, payload })
    },
    callback,
    errorCallback
  )
}

export const LOAD_WIZARD_BY_ID = (formDefinitionId, callback) => {
  fetchAndCatch(
    {
      url: `/api/FormDefinition/GetWizard/${formDefinitionId}`,
      method: 'GET'
    },
    callback
  )
}

export const LOAD_WIZARD_HISTORY_BY_ID = (formDefinitionId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/FormDefinition/GetWizardHistory/${formDefinitionId}`,
      method: 'GET'
    },
    callback,
    errorCallback
  )
}

export const LOAD_WIZARD_REVISION_STEPS_BY_ID = (formDefinitionId, revisionId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/FormDefinition/GetWizardRevisionSteps/${formDefinitionId}/${revisionId}`,
      method: 'GET'
    },
    callback,
    errorCallback
  )
}

export const LOAD_WIZARD_INJECT_METADATA = (
  formDefinitionId,
  amendmentNum = 'null',
  callback,
  errorCallback
) => {
  const query = store.getState().router.location.search || ''
  fetchAndCatch(
    {
      url: `/api/FormDefinition/GetWizardInjectMetadata/${formDefinitionId}/${amendmentNum}${query}`,
      method: 'GET'
    },
    callback,
    errorCallback
  )
}

export const SAVE_WIZARD = (wizard, callback, errorCallback) => {
  // console.log(wizard)
  fetchAndCatch(
    {
      url: `/api/FormDefinition/`,
      method: 'POST',
      body: JSON.stringify(wizard),
      auth: true
    },
    callback,
    errorCallback
  )
}

export const CLONE_WIZARD = (formDefinitionId, payload, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/FormDefinition/clone/${formDefinitionId}`,
      method: 'POST',
      body: JSON.stringify(payload),
      auth: true
    },
    callback,
    errorCallback
  )
}

export const ARCHIVE_WIZARD = (formDefinitionId, payload, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/FormDefinition/archive/${formDefinitionId}`,
      method: 'POST',
      body: JSON.stringify(payload),
      auth: true
    },
    callback,
    errorCallback
  )
}

const getFormDataObject = (files, payload = {}) => {
  let fileObject = new FormData()
  // console.log(files)
  Object.keys(files).forEach(key => {
    // console.log(key, files[key])
    fileObject.append('file', files[key])
  })
  Object.keys(payload).forEach(key => {
    fileObject.append(key, payload[key])
  })
  // console.log("fileObject", fileObject.getAll("file"));
  return fileObject
}

export const UPLOAD_FILES = (files, payload, onProgress) => {
  let opts = {}
  opts.body = getFormDataObject(files, payload)
  let AUTH = localStorage.getItem('WEB_USER_AUTHENTICATION')
  let auth = AUTH && AUTH !== 'undefined' ? JSON.parse(AUTH) : {}
  return new Promise((res, rej) => {
    var xhr = new XMLHttpRequest()
    xhr.open('POST', BASE_URL + '/api/FileUpload')
    xhr.setRequestHeader('Authorization', auth.ID)
    xhr.onload = e => res(e.target.responseText)
    xhr.onerror = rej
    if (xhr.upload && onProgress) xhr.upload.onprogress = onProgress
    //xhr.addEventListener("progress", onProgress)
    xhr.send(opts.body)
  })
}

export const SEARCH_REGISTERED_AGENTS = (payload, callback) => {
  fetchAndCatch(
    {
      url: '/api/RA',
      method: 'POST',
      body: JSON.stringify(payload)
    },
    callback
  )
}

export const GET_REGISTERED_AGENT_BY_ID = (id, callback) => {
  fetchAndCatch(
    {
      url: `/api/RA/${id}`,
      method: 'GET'
    },
    callback
  )
}
export const GET_BY_ID = (searchType, idAndQuery, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Search/${searchType}/${idAndQuery}`,
      method: 'GET'
    },
    callback,
    errorCallback
  )
}

export const GET_WORK_QUEUE_ITEMS = (category, parameters, requestId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/WorkQueue/${category}`,
      method: 'POST',
      auth: true,
      body: JSON.stringify(parameters),
      requestId
    },
    callback,
    errorCallback
  )
}
export const SAVE_RECORD = (json, category, mode, isCorrection, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/${category}/${mode}${isCorrection ? '/correct' : ''}`,
      method: 'POST',
      body: JSON.stringify({ json: JSON.stringify(json) }),
      auth: true
    },
    callback,
    errorCallback
  )
}

export const SAVE_RECORD_WITH_SIGNATURES = (
  json,
  category,
  isCorrection,
  callback,
  errorCallback
) => {
  const { extraPayload: extraPayload = {}, ...payload } = json
  fetchAndCatch(
    {
      url: `/api/Signature/${category}${isCorrection ? '/correct' : ''}`,
      method: 'POST',
      body: JSON.stringify({ json: JSON.stringify(payload), ...extraPayload })
    },
    callback,
    errorCallback
  )
}

export const GET_SIGNATURES_BY_GROUP_TOKEN = (groupToken, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Signature/${groupToken}`,
      method: 'GET'
    },
    callback,
    errorCallback
  )
}

export const SET_SIGNER_EMAIL_BY_TOKEN = ({ SIGNER_EMAIL, TOKEN }, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Signature/update-email/${TOKEN}`,
      method: 'POST',
      body: JSON.stringify({ SIGNER_EMAIL })
    },
    callback,
    errorCallback
  )
}

export const GET_SIGNATURE_FORM_BY_TOKEN = (token, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Signature/form/${token}`,
      method: 'GET'
    },
    callback,
    errorCallback
  )
}

export const RESEND_SIGNER_EMAIL = (token, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/signature/resend-email/${token}`,
      method: 'GET'
    },
    callback,
    errorCallback
  )
}

export const SAVE_SIGNATURE_BY_TOKEN_AND_CATEGORY = (
  { token, category, payload },
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: `/api/Signature/${token}/${category}`,
      method: 'POST',
      body: JSON.stringify(payload)
    },
    callback,
    errorCallback
  )
}

export const GET_FILING_TYPE_IDS = callback => {
  fetchAndCatch(
    {
      url: `/api/FilingType`,
      method: 'GET'
    },
    callback
  )
}

export const SAVE_DRAFT = (payload, callback) => {
  fetchAndCatch(
    {
      url: '/api/Draft',
      method: 'POST',
      body: JSON.stringify(payload),
      auth: true
    },
    callback
  )
}

export const DELETE_DRAFT_BY_ID = (draftId, callback) => {
  fetchAndCatch(
    {
      url: `/api/WorkQueue/DeleteDraft/${draftId}`,
      method: 'POST',
      auth: true
    },
    callback
  )
}

export const LOAD_DRAFT_BY_ID = (draftId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Draft/${draftId}`,
      method: 'GET',
      auth: true
    },
    callback,
    errorCallback
  )
}

export const LOAD_AMENDMENT_BY_ID = (
  amendmentNum,
  category,
  mode,
  isCorrection,
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: `/api/${category}/${mode}/${amendmentNum}/${isCorrection}`,
      method: 'GET',
      auth: true
    },
    callback,
    errorCallback
  )
}

export const DELETE_RECORD_BY_ID = (draftId, category, callback) => {
  fetchAndCatch(
    {
      url: `/api/WorkQueue/DeleteRecord/${category}/${draftId}`,
      method: 'POST',
      auth: true
    },
    callback
  )
}

export const GET_HOME_PAGE_STRUCTURE = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/home`,
      method: 'GET'
    },
    callback,
    errorCallback
  )
}

export const GET_APP_SETTING_BY_NAME = (name, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/AppSetting/${name}`,
      method: 'GET'
    },
    callback,
    errorCallback
  )
}

export const GET_APP_SETTINGS_BY_NAME = (settingNames, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/AppSetting/getSettingsByName`,
      method: 'POST',
      body: JSON.stringify(settingNames)
    },
    callback,
    errorCallback
  )
}

export const GET_AVAILABLE_APP_SETTINGS = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/AppSetting/getAvailableAppSettings`,
      method: 'GET'
    },
    callback,
    errorCallback
  )
}

export const SAVE_APP_SETTING_BY_NAME = (payload, callback) => {
  fetchAndCatch(
    {
      url: '/api/AppSetting',
      method: 'POST',
      body: JSON.stringify(payload),
      auth: true
    },
    callback
  )
}

export const UPDATE_APP_SETTING_BY_ID = (id, payload, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/AppSetting/${id}`,
      method: 'POST',
      body: JSON.stringify(payload)
    },
    callback,
    errorCallback
  )
}

export const CREATE_WEB_USER = (payload, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: '/api/Auth/createWebUser',
      method: 'POST',
      body: JSON.stringify(payload)
    },
    callback,
    errorCallback
  )
}

export const SEND_PASSWORD_RESET_EMAIL = (payload, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: '/api/Auth/sendPasswordReset',
      method: 'POST',
      body: JSON.stringify(payload)
    },
    callback,
    errorCallback
  )
}

export const CHANGE_PASSWORD = (payload, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: '/api/Auth/changePassword',
      method: 'POST',
      body: JSON.stringify(payload)
    },
    callback,
    errorCallback
  )
}

export const PARSE_PASSWORD_RESET_TOKEN = (token, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: '/api/Auth/parseResetToken',
      method: 'POST',
      body: JSON.stringify({ token })
    },
    callback,
    errorCallback
  )
}

export const LOGIN_WEB_USER = (payload, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: '/api/Auth/login',
      method: 'POST',
      body: JSON.stringify(payload)
    },
    callback,
    errorCallback
  )
}

export const LOGIN_APP_USER = (payload, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: '/api/Auth/app_login',
      method: 'POST',
      body: JSON.stringify(payload)
    },
    callback,
    errorCallback
  )
}

export const LOGOUT_WEB_USER = callback => {
  fetchAndCatch(
    {
      url: '/api/Auth/logout',
      method: 'GET',
      auth: true
    },
    callback
  )
}

export const GET_AUTH_STATE = callback => {
  fetchAndCatch(
    {
      url: '/api/Auth',
      method: 'GET',
      auth: true
    },
    callback
  )
}

export const EXTEND_WEB_USER_SESSION = (staleToken, callback) => {
  fetchAndCatch(
    {
      url: `/api/Auth/extend?staletoken=${staleToken}`,
      method: 'GET',
      auth: true
    },
    callback
  )
}

export const GET_RECEIPT_ITEMS_BY_ADMENDMENT_NUM = (
  amendmentNum,
  category,
  correctionMode,
  callback,
  errorCallback
) => {
  // console.log(amendmentNum);
  fetchAndCatch(
    {
      url: `/api/${category}/getWebCart/${amendmentNum}/${correctionMode}`,
      method: 'GET',
      auth: true
    },
    callback,
    errorCallback
  )
}

export const GET_WEB_CART_BY_REF_NUM = (refNum, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Payment/getWebCart/${refNum}`,
      method: 'GET',
      auth: false
    },
    callback,
    errorCallback
  )
}

export const REMOVE_FROM_WEB_CART_BY_GUID = (guid, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Payment/removeFromCart/${guid}`,
      method: 'GET',
      auth: true
    },
    callback,
    errorCallback
  )
}

export const GET_WEB_USER_ACTIVE_CART = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Payment/getWebUserActiveCart`,
      method: 'GET',
      auth: false
    },
    callback,
    errorCallback
  )
}

export const POST_PAYMENT = (payload, category, callback) => {
  fetchAndCatch(
    {
      url: `/api/${category}/getWebCart`,
      method: 'POST',
      body: JSON.stringify({ type: 'CREDIT', ...payload }),
      auth: true
    },
    callback
  )
}

export const BYPASS_PAYMENT = (payload, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/payment/activate`,
      method: 'POST',
      body: JSON.stringify(payload),
      auth: true
    },
    callback,
    errorCallback
  )
}

export const SEARCH_BY_KEY = (searchTypeKey, payload, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Search/${searchTypeKey}`,
      method: 'POST',
      body: JSON.stringify(payload),
      auth: true
    },
    callback,
    errorCallback
  )
}

export const GET_WEB_USER_RECORD = (payload, callback) => {
  fetchAndCatch(
    {
      url: `/api/WebUserRecord`,
      method: 'POST',
      auth: true,
      body: JSON.stringify(payload)
    },
    callback
  )
}

export const GET_WEB_USER_ACCESS_LIST = (category = 'business', sourceId, callback) => {
  fetchAndCatch(
    {
      url: `/api/WebUserAccess/${getSourceTypeId(category)}/${sourceId}`,
      method: 'GET',
      auth: true
    },
    callback
  )
}

export const GET_RECORD_PINS = (category = 'business', sourceId, callback) => {
  fetchAndCatch(
    {
      url: `/api/Pin/${getSourceTypeId(category)}/${sourceId}`,
      method: 'GET',
      auth: true
    },
    callback
  )
}

export const REQUEST_NEW_PIN = (category = 'business', sourceId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Pin`,
      method: 'POST',
      auth: true,
      body: JSON.stringify({ SOURCE_TYPE_ID: getSourceTypeId(category), SOURCE_ID: sourceId })
    },
    callback,
    errorCallback
  )
}

export const GET_WEB_USER_ACCESS_WITH_PIN = (payload, callback) => {
  fetchAndCatch(
    {
      url: `/api/Pin/validatePin`,
      method: 'POST',
      auth: true,
      body: JSON.stringify(payload)
    },
    callback
  )
}

export const GET_WEB_USER_ACCESS_WITH_GENERIC_PIN = (pin, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Pin/validateGenericPin/${pin}`,
      method: 'GET',
      auth: true
    },
    callback,
    errorCallback
  )
}

export const GET_WEB_USER_IS_RECORD_OWNER = (category = 'business', sourceId, callback) => {
  fetchAndCatch(
    {
      url: `/api/WebUserAccess/GET_USER_IS_OWNER`,
      method: 'POST',
      auth: true,
      body: JSON.stringify({ SOURCE_TYPE_ID: getSourceTypeId(category), SOURCE_ID: sourceId })
    },
    callback
  )
}

export const GET_RECORD_HAS_OWNERS = (category = 'business', sourceId, callback) => {
  fetchAndCatch(
    {
      url: `/api/WebUserAccess/GET_RECORD_HAS_OWNERS`,
      method: 'POST',
      auth: true,
      body: JSON.stringify({ SOURCE_TYPE_ID: getSourceTypeId(category), SOURCE_ID: sourceId })
    },
    callback
  )
}

export const GET_RECORD_HAS_ACTIVE_PIN = (category = 'business', sourceId, callback) => {
  fetchAndCatch(
    {
      url: `/api/Pin/GET_RECORD_HAS_ACTIVE_PIN`,
      method: 'POST',
      auth: true,
      body: JSON.stringify({ SOURCE_TYPE_ID: getSourceTypeId(category), SOURCE_ID: sourceId })
    },
    callback
  )
}

export const REQUEST_RECORD_ACCESS = (category = 'business', sourceId, callback) => {
  fetchAndCatch(
    {
      url: `/api/WebUserAccess/REQUEST_RECORD_ACCESS`,
      method: 'POST',
      auth: true,
      body: JSON.stringify({ SOURCE_TYPE_ID: getSourceTypeId(category), SOURCE_ID: sourceId })
    },
    callback
  )
}

export const GET_USER_HAS_ALREADY_REQUESTED_WEB_USER_ACCESS = (
  category = 'business',
  sourceId,
  callback
) => {
  fetchAndCatch(
    {
      url: `/api/WebUserAccess/GET_USER_HAS_ALREADY_REQUESTED`,
      method: 'POST',
      auth: true,
      body: JSON.stringify({ SOURCE_TYPE_ID: getSourceTypeId(category), SOURCE_ID: sourceId })
    },
    callback
  )
}

export const REJECT_RECORD_ACCESS_REQUEST = (webUserAccessId, callback) => {
  fetchAndCatch(
    {
      url: `/api/WebUserAccess/REJECT_RECORD_ACCESS_REQUEST`,
      method: 'POST',
      auth: true,
      body: JSON.stringify({ WEB_USER_ACCESS_ID: webUserAccessId })
    },
    callback
  )
}

export const ACCEPT_RECORD_ACCESS_REQUEST = (webUserAccessId, callback) => {
  fetchAndCatch(
    {
      url: `/api/WebUserAccess/ACCEPT_RECORD_ACCESS_REQUEST`,
      method: 'POST',
      auth: true,
      body: JSON.stringify({ WEB_USER_ACCESS_ID: webUserAccessId })
    },
    callback
  )
}

export const REVOKE_RECORD_ACCESS = (webUserAccessId, callback) => {
  fetchAndCatch(
    {
      url: `/api/WebUserAccess/REVOKE_RECORD_ACCESS`,
      method: 'POST',
      auth: true,
      body: JSON.stringify({ WEB_USER_ACCESS_ID: webUserAccessId })
    },
    callback
  )
}

export const GET_AVAILABLE_AMENDMENTS = (filingNum, category, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Amendment/GetAvailable${category}Amendments/${filingNum}`,
      method: 'GET',
      auth: true
    },
    callback,
    errorCallback
  )
}

export const GET_AR_FORM_DEFINITION_ID = (filingNum, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Amendment/GetARFormDefinitionId/${filingNum}`,
      method: 'GET'
    },
    callback,
    errorCallback
  )
}

export const GET_REINSTATEMENT_FORM_DEFINITION_ID = (filingNum, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Amendment/GetReinstatementFormDefinitionId/${filingNum}`,
      method: 'GET'
    },
    callback,
    errorCallback
  )
}

export const GET_CONTRACTOR_RENEWAL_FORM_DEFINITION_ID = (filingNum, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Amendment/GetContractorRenewalFormDefinitionId/${filingNum}`,
      method: 'GET'
    },
    callback,
    errorCallback
  )
}

export const GET_CHARITABLE_AR_FORM_DEFINITION_ID = (filingNum, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Amendment/GetCharitableARFormDefinitionId/${filingNum}`,
      method: 'GET'
    },
    callback,
    errorCallback
  )
}

export const GET_CHARITABLE_RENEWAL_FORM_DEFINITION_ID = (filingNum, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Amendment/GetCharitableRenewalFormDefinitionId/${filingNum}`,
      method: 'GET'
    },
    callback,
    errorCallback
  )
}

export const GET_LOBBYIST_RENEWAL_FORM_DEFINITION_ID = (filingNum, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Amendment/GetLobbyistRenewalFormDefinitionId/${filingNum}`,
      method: 'GET'
    },
    callback,
    errorCallback
  )
}

export const GET_TRADEMARK_RENEWAL_FORM_DEFINITION_ID = (filingNum, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Amendment/GetTrademarkRenewalFormDefinitionId/${filingNum}`,
      method: 'GET'
    },
    callback,
    errorCallback
  )
}

export const GET_NOTARY_RENEWAL_FORM_DEFINITION_ID = (filingNum, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Amendment/GetNotaryRenewalFormDefinitionId/${filingNum}`,
      method: 'GET'
    },
    callback,
    errorCallback
  )
}

export const GET_REPORT_PREVIEW = (payload, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Report`,
      method: 'POST',
      auth: true,
      raw: true,
      body: JSON.stringify(payload)
    },
    callback,
    errorCallback
  )
}

export const GET_REPORT_BY_JSON = (payload, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Report`,
      method: 'POST',
      auth: true,
      raw: true,
      body: JSON.stringify(payload)
    },
    callback,
    errorCallback
  )
}

export const GET_REPORTS = (formDefinitionId, record_num, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Report/${formDefinitionId}/${record_num}`,
      method: 'GET'
    },
    callback,
    errorCallback
  )
}

export const GET_REPORT_BY_REPORT_OBJECT = (payload, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Report/getbyreportobject`,
      method: 'POST',
      raw: true,
      body: JSON.stringify(payload)
    },
    callback,
    errorCallback
  )
}

export const GET_PAYPAL_TOKEN = (refNum, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Payment/getPaypalToken/${refNum}`,
      method: 'GET'
    },
    callback,
    errorCallback
  )
}

export const GET_ACCESSIDCC_TOKEN = (refNum, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Payment/getAccessIDCCToken/${refNum}`,
      method: 'GET'
    },
    callback,
    errorCallback
  )
}

export const GET_ACCESSIDLOC_TOKEN = (refNum, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Payment/getAccessIDLOCToken/${refNum}`,
      method: 'GET'
    },
    callback,
    errorCallback
  )
}

export const GET_SERVER_DATES = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Date`,
      method: 'GET'
    },
    callback,
    errorCallback
  )
}

export const GET_DATA_TABLES = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/DataTable`,
      method: 'GET'
    },
    callback,
    errorCallback
  )
}

export const GET_DATA_TABLE_BY_ID = (id, metadata = {}, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/DataTable/GetById/${id}`,
      method: 'POST',
      body: JSON.stringify(metadata),
      auth: true
    },
    callback,
    errorCallback
  )
}

export const GET_ALL_MERGE_CODES = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/MergeCode/GetList`,
      method: 'GET',
      auth: true
    },
    callback,
    errorCallback
  )
}

export const GET_MERGE_CODES_BY_ARRAY = (mergeCodes, metaData, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/MergeCode/getValues`,
      method: 'POST',
      body: JSON.stringify({
        mergeCodes,
        metaData
      }),
      auth: true
    },
    callback,
    errorCallback
  )
}

export const GET_RECORD_HISTORY = (category, amendmentNum, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/History/${category}/${amendmentNum}`,
      method: 'GET',
      auth: true
    },
    callback,
    errorCallback
  )
}

export const GET_LOBBYISTS_BY_SEARCH_AND_RANGE = (year, searchValue, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/list/search`,
      method: 'POST',
      body: JSON.stringify({
        YEAR: year,
        SEARCH_VALUE: searchValue
      })
    },
    callback,
    errorCallback
  )
}

export const GET_LOBBYIST_ENTITIES_BY_ID = (lobbyistId, year, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/list/getEntitiesByID/${lobbyistId}/${year}`,
      method: 'get'
    },
    callback,
    errorCallback
  )
}

export const GET_AVAILABLE_LISTS = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/list/getAvailableLists`,
      method: 'get'
    },
    callback,
    errorCallback
  )
}

export const GET_HCDR_RECORD = (payload, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/records/hcdrsearch`,
      method: 'POST',
      body: JSON.stringify(payload)
    },
    callback,
    errorCallback
  )
}

export const GET_APOSTILLE_RECORD = (payload, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/records/apostillesearch`,
      method: 'POST',
      body: JSON.stringify(payload)
    },
    callback,
    errorCallback
  )
}

export const GET_ACCESS_ID_CC_PAYMENT_STATUS = (token, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/payment/getAccessIDCCPaymentStatus/${token}`,
      method: 'GET'
    },
    callback,
    errorCallback
  )
}

export const GET_ACCESS_ID_LOC_PAYMENT_STATUS = (token, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/payment/getAccessIDLOCPaymentStatus/${token}`,
      method: 'GET'
    },
    callback,
    errorCallback
  )
}

export const GET_PAYPAL_PAYMENT_STATUS = (token, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/payment/getPaypalPaymentStatus/${token}`,
      method: 'GET'
    },
    callback,
    errorCallback
  )
}

export const GET_CERTIFICATION_CONFIG = (category, filingId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Certification/getCertificationConfig/${category}/${filingId}`,
      method: 'GET'
    },
    callback,
    errorCallback
  )
}

export const CREATE_CERTIFICATION = (payload, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Certification`,
      method: 'POST',
      body: JSON.stringify(payload)
    },
    callback,
    errorCallback
  )
}

export const GET_WEB_CART_BY_CERTIFICATION_ID = (certificationId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Certification/getWebCart/${certificationId}`,
      method: 'GET'
    },
    callback,
    errorCallback
  )
}

export const GET_REPORTS_BY_WEB_CART_REF_NUM = (refNum, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Report/GetReportsByCartRefNum/${refNum}`,
      method: 'GET'
    },
    callback,
    errorCallback
  )
}

export const GET_AVAILABLE_PAYMENT_METHODS = (refNum, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Payment/getPaymentMethodStatus/${refNum}`,
      method: 'GET'
    },
    callback,
    errorCallback
  )
}

export const VERIFY_CERTIFICATE = (ref_num, category, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/certification/verifyCertificate/${ref_num}${category ? `?category=${category}` : ''}`,
      method: 'GET'
    },
    callback,
    errorCallback
  )
}

export const SEARCH_UCC_INFO_REQ = (payload, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/records/uccinforeqsearch`,
      method: 'POST',
      body: JSON.stringify(payload)
    },
    callback,
    errorCallback
  )
}

export const GET_DASHBOARD_DATA = (payload, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/DashboardTile/getData`,
      method: 'POST',
      body: JSON.stringify(payload)
    },
    callback,
    errorCallback
  )
}

export const GET_LIENS_SEARCH_WEB_CART = (payload, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/copies/premium`,
      method: 'POST',
      body: JSON.stringify(payload)
    },
    callback,
    errorCallback
  )
}

export const UPDATE_WEB_USER = (payload, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/auth/updateWebUser`,
      method: 'POST',
      body: JSON.stringify(payload)
    },
    callback,
    errorCallback
  )
}

export const GET_PAYROC_CUSTOMER = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Payment/PayrocCustomerGet`,
      method: 'GET'
    },
    callback,
    errorCallback
  )
}

export const CREATE_PAYROC_TRANSACTION = (payload, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Payment/PayrocTransactionCreate`,
      method: 'POST',
      body: JSON.stringify(payload)
    },
    callback,
    errorCallback
  )
}

export const CREATE_PAYROC_CUSTOMER_PAYMENT_SOURCE = (payload, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Payment/PayrocAddPaymentSource`,
      method: 'POST',
      body: JSON.stringify(payload)
    },
    callback,
    errorCallback
  )
}

export const DELETE_PAYROC_CUSTOMER_PAYMENT_SOURCE = (id, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Payment/PayrocDeletePaymentSource`,
      method: 'POST',
      body: JSON.stringify({ id })
    },
    callback,
    errorCallback
  )
}

export const GET_DATA_REQUEST_WIZARDS = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Data-Request/GetDataRequestDefinitions`,
      method: 'GET'
    },
    callback,
    errorCallback
  )
}

export const GET_MY_DATA_REQUESTS = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Data-Request/GetList`,
      method: 'GET'
    },
    callback,
    errorCallback
  )
}

export const UPDATE_DATA_REQUEST = (payload, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: '/api/data-request/Update',
      method: 'POST',
      body: JSON.stringify(payload)
    },
    callback,
    errorCallback
  )
}

export const GET_EPASS_LOGIN_CALLBACK = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: '/api/Epass/ProcessLogin',
      method: 'GET',
      cookies: true
    },
    callback,
    errorCallback
  )
}

export const GET_HAS_FARM_BILL_SUBSCRIPTION = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: '/api/list/getHasFarmBillSubscription',
      method: 'GET'
    },
    callback,
    errorCallback
  )
}

export const GET_UCC_XML_USERS = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: '/api/customerprofile/getlist',
      method: 'GET'
    },
    callback,
    errorCallback
  )
}

export const GET_XML_PAYROC_CUSTOMER = (profileId, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/customerprofile/PayrocCustomerGet/${profileId}`,
      method: 'GET'
    },
    callback,
    errorCallback
  )
}

export const ADD_XML_PAYROC_PAYMENT_METHOD = ({ profileId, token }, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/customerprofile/PayrocAddPaymentSource`,
      method: 'POST',
      body: JSON.stringify({ profileId, token })
    },
    callback,
    errorCallback
  )
}

export const SET_XML_PAYROC_DEFAULT_PAYMENT_METHOD = (
  { profileId, paySourceNum },
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: `/api/customerprofile/PayrocSetDefaultPaymentSource`,
      method: 'POST',
      body: JSON.stringify({ profileId, paySourceNum })
    },
    callback,
    errorCallback
  )
}

export const SET_XML_PAYROC_DELETE_PAYMENT_METHOD = (
  { profileId, paySourceNum },
  callback,
  errorCallback
) => {
  fetchAndCatch(
    {
      url: `/api/customerprofile/PayrocDeletePaymentSource`,
      method: 'POST',
      body: JSON.stringify({ profileId, paySourceNum })
    },
    callback,
    errorCallback
  )
}

export const SET_WEB_USER_ACCESS_LEVEL = (payload, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/WebUserAccess/SET_ACCESS_LEVEL`,
      method: 'POST',
      body: JSON.stringify(payload)
    },
    callback,
    errorCallback
  )
}

export const GET_CURRENT_USER_FREQUENT_PAYOR_ACCOUNT = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/web-user/-/frequent-payor`,
      method: 'GET'
    },
    callback,
    errorCallback
  )
}

export const UPDATE_FREQUENT_PAYOR_ADDRESS = (payload, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/web-user/updateAddress/frequent-payor`,
      method: 'POST',
      body: JSON.stringify(payload)
    },
    callback,
    errorCallback
  )
}

export const WEB_CART_TRANSACTION_WITH_FREQUENT_PAYOR = (refNum, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Payment/payWithFrequentPayor/${refNum}`,
      method: 'POST'
    },
    callback,
    errorCallback
  )
}

export const WEB_CART_GUIDS_TRANSACTION_WITH_FREQUENT_PAYOR = (payload, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Payment/payWithFrequentPayor`,
      method: 'POST',
      body: JSON.stringify(payload),
      auth: true
    },
    callback,
    errorCallback
  )
}

export const GET_FREQUENT_PAYOR_WEBCART_FROM_AMOUNT = (amount, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/frequent-payor/getWebCart/${amount * 100}`,
      method: 'GET'
    },
    callback,
    errorCallback
  )
}

export const GET_FREQUENT_PAYOR_STATEMENT = (date, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/report/frequentPayorStatement?date=${date}`,
      method: 'GET',
      raw: true
    },
    callback,
    errorCallback
  )
}

export const GET_ELAVON_TOKEN_BY_REF_NUM = (refNum, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Payment/getElavonToken/${refNum}`,
      method: 'POST'
    },
    callback,
    errorCallback
  )
}

export const GET_ELAVON_TOKEN_BY_ITEM_GUIDS = (payload, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Payment/getElavonToken`,
      method: 'POST',
      body: JSON.stringify(payload),
      auth: true
    },
    callback,
    errorCallback
  )
}

export const PROCESS_ELAVON_PAYMENT = (body, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Payment/elavonactivate`,
      method: 'POST',
      body: JSON.stringify(body)
    },
    callback,
    errorCallback
  )
}

export const GET_VERSION_INFO = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/VersionInfo`,
      method: 'GET'
    },
    callback,
    errorCallback
  )
}

export const GET_REGULATED_WORD_LISTS = (callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/RegulatedWord`,
    },
    callback,
    errorCallback
  )
}

export const CLEAR_FAILED_WEB_CART_BY_REF_NUM = (refNum, callback, errorCallback) => {
  fetchAndCatch(
    {
      url: `/api/Payment/clearFailedCart/${refNum}`,
      method: 'POST'
    },
    callback,
    errorCallback
  )
}


// WEBPACK FOOTER //
// ./src/requests.js